import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

function NRAccessError({ onRetry }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        margin: theme.spacing(1, 1, 0),
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default
      }}
    >
      <Typography sx={{ marginTop: theme.spacing(2) }} variant="label" color={theme.palette.neutral[300]}>
        Unable to Verify Access
      </Typography>
      <Typography variant="caption" sx={{ marginTop: theme.spacing(2), textAlign: 'center', maxWidth: 480 }}>
        We could not confirm your permissions for this organization.
      </Typography>
      <Typography variant="caption" sx={{ textAlign: 'center', maxWidth: 480 }}>
        Please try again. If the problem persists, contact your administrator.
      </Typography>
      <Box display="flex" mt={2} gap={2}>
        <Button variant="contained" color="secondary" onClick={onRetry}>
          Try Again
        </Button>
      </Box>
    </Box>
  );
}

export default NRAccessError;
